import React from 'react';
import FormGroup from './FormGroup';
import { Controller } from 'react-hook-form';
import { ToggleSwitch } from './ToggleSwitch';

/** Props for FormToggleBool - most are optional */
export interface FormToggleBoolProps {
  name?: string;
  control: any;
  label?: string;
  defaultValue?: boolean;
  placeholder?: string;
  register?: any;
  error?: any;
  errorMessage?: string;
  required?: boolean;
  yesText?: string;
  noText?: string;
  onChange?: any;
  helpContent?: string;
  testId?: string;
  disabled?: boolean;
}

const FormToggleBool = ({
  label,
  name,
  defaultValue,
  placeholder,
  register,
  error,
  errorMessage,
  control,
  required,
  yesText,
  noText,
  onChange,
  helpContent,
  testId,
  disabled,
}: FormToggleBoolProps) => {
  return (
    <FormGroup
      label={label}
      error={error}
      errorMessage={errorMessage}
      required={required}
      helpContent={helpContent}
    >
      <Controller
        name={name ?? ''}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange } }) => (
          <ToggleSwitch
            label={label}
            value={defaultValue}
            onChange={onChange}
            disabled={disabled ?? false}
            testId={testId}
          />
        )}
      />
    </FormGroup>
  );
};
export default FormToggleBool;
